import { EventTemplate } from "types/graphql";

export const EVENT_TEMPLATE_ON_DAY_CHECK_IN = 0;
export const EVENT_TEMPLATE_ON_DAY_CHECK_OUT = -1;
export const EVENT_TEMPLATE_ON_DAY_ROOM_CHANGE = -2;

export const systemTemplates: { checkIn: EventTemplate, checkOut: EventTemplate } = {
    "checkIn": {
        name: "check-in",
        id: 1,
        onDay: EVENT_TEMPLATE_ON_DAY_CHECK_IN,
        isSystem: true,
        isActive: true,
        repeat: false,
        normalizedName: "check-in|check in",
        changeDynamicly: false,
        order: 100
    },
    "checkOut": {
        name: "check-out",
        id: 2,
        onDay: EVENT_TEMPLATE_ON_DAY_CHECK_IN,
        isSystem: true,
        isActive: true,
        repeat: false,
        normalizedName: "check-out|check out",
        changeDynamicly: false,
        order: 1
    }
}
